import * as u from "react";
import { i as m, E as b, x as n, a as h, r as x, c as v } from "../createReactComponent-58f9bea8.mjs";
import { n as c } from "../property-9daa16cd.mjs";
import { r as g } from "../state-7560d4dc.mjs";
import { e as P } from "../query-d94c86d2.mjs";
import { e as f } from "../class-map-2994e95e.mjs";
import { r as y } from "../icon-button-87ac6b5d.mjs";
import { b as k, a as w } from "../menu-item-group-4d9c93fd.mjs";
import { r as z } from "../button-7600b6ca.mjs";
import { r as $ } from "../menu-item-65dd9fa4.mjs";
import { g as p } from "../utils-cf5bbdd1.mjs";
import "../base-e16d29d8.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
import "../if-defined-47693dfa.mjs";
import "../live-6c85dd15.mjs";
import "../purify.es-39f8036b.mjs";
import "../slot-controller-fa97ce97.mjs";
import "../menu-3df3d7c3.mjs";
import "../style-map-c3339321.mjs";
import "../pill-5555e08e.mjs";
import "../pill-group-b0c315ae.mjs";
import "../checkbox-46b40c6a.mjs";
import "../radio-8b0e9514.mjs";
const N = m`
  /** LIGHT MODE */

  :host .button,
  :host a {
    font: var(--exo-text-label-standard-semi-bold);
    line-height: var(--exo-line-height-denser);
    color: var(--exo-color-font-inverse);
    background-color: var(--exo-color-background-selected);
    border: var(--exo-spacing-4x-small) solid transparent;
    height: var(--exo-spacing-x-large);
    border-radius: calc(var(--exo-radius-small) * 2);
    cursor: pointer;
    transition: background-color var(--exo-time-standard) ease;
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-small);
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    box-sizing: border-box;
    position: relative;
  }

  /*CSS for base flavor starts here*/

  :host .button--resting {
    background: none;
    border: var(--exo-spacing-4x-small) solid transparent;
    color: var(--exo-color-font);
  }

  ex-select ::part(select_icon) {
    display: none;
  }

  :host .button--resting:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
  }

  :host .button--resting:focus-visible {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
    outline: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .button--resting:active {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
    outline: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .button--activated {
    background-color: var(--exo-color-background-selected-weak);
    border: var(--exo-spacing-4x-small) solid transparent;
    color: var(--exo-color-background-selected);
  }

  :host .button--activated:hover {
    background-color: var(--exo-color-background-selected-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected-hover);
    color: var(--exo-color-background-selected-hover);
  }

  :host .button--activated:focus-visible {
    background-color: var(--exo-color-background-selected-weak);
    border: var(--exo-spacing-4x-small) solid transparent;
    color: var(--exo-color-background-selected-hover);
  }

  :host .button--activated:active {
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected-hover);
    color: var(--exo-color-background-selected-hover);
    background: var(--exo-color-background-selected-weak);
  }

  :host .pagination--wrapper {
    position: relative;
    padding: var(--exo-spacing-2x-small);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--exo-spacing-large);
    box-sizing: border-box;
    transition:
      background-color var(--exo-time-standard) ease,
      border-radius var(--exo-time-standard) ease;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    font-size: var(--exo-font-size-small);
  }

  :host .pagination--wrapper #pagination--options,
  :host .pagination--wrapper #pagination--jump {
    display: flex;
    align-items: center;
  }

  :host .pagination--wrapper #pagination--options {
    margin-right: auto;
  }

  :host .pagination--wrapper #pagination--jump ex-button {
    margin-left: var(--exo-spacing-2x-small);
  }

  :host .pagination--wrapper #pagination--options ex-select {
    width: calc(var(--exo-size-3) / 4);
    min-width: calc(var(--exo-size-3) / 4 - var(--exo-size-1) / 10);
  }

  :host .pagination--wrapper #pagination--jump ex-input {
    width: calc(var(--exo-size-3) / 4 - var(--exo-size-1) / 20);
    min-width: calc(var(--exo-size-3) / 4 - var(--exo-size-1) / 20);
  }

  :host .pagination--wrapper .pagination--numbers {
    display: flex;
    justify-content: center;
    gap: var(--exo-spacing-x-small);
  }

  :host
    .pagination--wrapper
    .pagination--numbers
    ex-icon-button::part(icon-button) {
    font-size: var(--exo-font-size-3x-large);
  }

  :host .pagination--wrapper .pagination--filler {
    width: var(--exo-spacing-large);
    text-align: center;
    padding: var(--exo-spacing-none) var(--exo-spacing-x-small);
    color: var(--exo-color-font);
  }

  :host .pagination--wrapper .pagination--label {
    font-size: var(--exo-font-size-small);
    color: var(--exo-color-font-secondary);
    margin-right: var(--exo-spacing-x-small);
    white-space: nowrap;
  }

  :host .pagination-left-side,
  :host .pagination-right-side {
    display: flex;
    justify-content: flex-start;
    gap: var(--exo-spacing-x-small);
    align-items: center;
  }
`;
var S = Object.defineProperty, M = Object.getOwnPropertyDescriptor, s = (o, e, t, a) => {
  for (var r, l = a > 1 ? void 0 : a ? M(e, t) : e, d = o.length - 1; d >= 0; d--)
    (r = o[d]) && (l = (a ? r(e, t, l) : r(l)) || l);
  return a && l && S(e, t, l), l;
};
const I = [10, 20, 50], te = 7;
var O = ((o) => (o.COMPACT = "compact", o.DEFAULT = "default", o))(O || {});
class i extends b {
  constructor() {
    super(), this.totalItems = 0, this.pageSize = 10, this.pageSizeOptions = I, this.selectedPage = 1, this.type = "default", this.hideControls = !1, this.hideGoToPage = !1, this.hideItemPerPage = !1, this.resizeObserver = null, this.isMobileView = !1, this.pageNumber = 1, this.pageInSeq = 3, this.pageBreak = 5, this.renderingMode = "default", this.observeResizePaginationHandler = () => {
      if (!this.paginationWrapper)
        return;
      this.resizeObserver && this.resizeObserver.disconnect();
      const e = function(t, a) {
        let r = null;
        return function(...l) {
          r !== null && clearTimeout(r), r = window.setTimeout(() => {
            t.apply(this, l);
          }, 100);
        };
      }(this.handleResize);
      this.resizeObserver = new ResizeObserver((t) => {
        try {
          e(t);
        } catch {
        }
      }), this.resizeObserver.observe(this.paginationWrapper);
    }, this.handleResize = this.handleResize.bind(this);
  }
  firstUpdated() {
    this.calculateMaxPageNum(), this.type === "compact" && (this.renderingMode = "compact", this.isMobileView = !0), this.type !== "compact" && this.observeResizePaginationHandler();
  }
  handleResize(e) {
    if (e.length === 0)
      return;
    const [{ contentRect: { width: t } }] = e, a = t < 576, r = a || t < 769 && this.type !== "compact" ? "compact" : "default";
    this.isMobileView === a && this.renderingMode === r || (this.isMobileView = a, this.renderingMode = r, this.requestUpdate());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.resizeObserver && this.resizeObserver.disconnect();
  }
  getPagination() {
    if (this.totalPages = Math.ceil(this.totalItems / this.pageSize), this.renderingMode === "compact" || this.type === "compact") {
      const t = "activated";
      return [this.renderPage(t, this.selectedPage)];
    }
    return Array.from({ length: this.totalPages }, (t, a) => a + 1).map((t) => {
      const a = this.selectedPage === t ? "activated" : "resting";
      if (this.totalPages < 7)
        return this.renderPage(a, t);
      if (this.totalPages >= 7) {
        const r = this.getPaginationForMorePages(t, a);
        if (r)
          return r;
      }
      return "";
    });
  }
  getPaginationForMorePages(e, t) {
    if (this.selectedPage <= this.pageInSeq) {
      if (e <= this.pageBreak)
        return this.renderPage(t, e);
      if (e === this.totalPages)
        return n`<span class="pagination--filler">...</span>
          ${this.renderPage(t, e)}`;
    }
    if (this.selectedPage > this.pageInSeq && this.selectedPage <= this.totalPages - this.pageBreak) {
      const a = this.getPaginationForMiddleOfSequence(e, t);
      if (a)
        return a;
    }
    if (this.selectedPage > this.totalPages - this.pageBreak) {
      if (e === 1)
        return n`${this.renderPage(t, e)}
          <span class="pagination--filler">...</span>`;
      if (e > this.totalPages - this.pageBreak)
        return this.renderPage(t, e);
    }
    return !1;
  }
  getPaginationForMiddleOfSequence(e, t) {
    let a;
    return a = this.type === "compact" || this.isMobileView || this.renderingMode === "compact" ? [this.selectedPage] : [this.selectedPage - 1, this.selectedPage, this.selectedPage + 1], !(!a.includes(e) && e !== 1 && e !== this.totalPages) && (e === 1 ? n`${this.renderPage(t, e)}<span
            class="pagination--filler"
            >...</span
          >` : e === this.totalPages ? n`<span class="pagination--filler">...</span
          >${this.renderPage(t, e)}` : this.renderPage(t, e));
  }
  renderPage(e, t) {
    return n`<span
      class=${f({ button: !0, "button--activated": e === "activated", "button--resting": e === "resting" })}
      tabindex="0"
      @click=${() => this.goToPage(t)}
      @keydown=${(a) => this.onKeyEnterPage(a, t)}
      >${t}</span
    >`;
  }
  onKeyEnterPage(e, t) {
    e.key !== "Enter" && e.code !== "Enter" || (this.goToPage(t), e.target.blur());
  }
  goToPage(e) {
    e > 0 && e <= this.totalPages && (this.selectedPage = e, this.dispatchPaginationEvent());
  }
  updatePageNumber(e) {
    this.pageNumber = Number(e.target.value);
  }
  updateRecordsPerPage(e) {
    var a;
    const t = Number((a = e == null ? void 0 : e.detail) == null ? void 0 : a.value);
    t && (this.pageSize = Number(t), this.selectedPage = 1), this.maxPageNum = Math.ceil(this.totalItems / this.pageSize), this.pageNumber > this.maxPageNum && (this.pageNumber = 1), e.stopPropagation(), this.dispatchPaginationEvent();
  }
  dispatchPaginationEvent() {
    const e = { pageSize: this.pageSize, selectedPage: this.selectedPage };
    this.dispatchCustomEvent("on-change", e);
  }
  onKeyEnter(e) {
    e.key !== "Enter" && e.code !== "Enter" || (this.updatePageNumber(e), this.goToPage(this.pageNumber)), e.key !== "ArrowUp" && e.key !== "ArrowDown" || this.updatePageNumber(e);
  }
  calculateMaxPageNum() {
    this.maxPageNum = Math.ceil(this.totalItems / this.pageSize);
  }
  getPaginationLeftSide(e) {
    return n` <div class="pagination-left-side">
      <div id="pagination--options" class="pagination-Item-per-page">
        ${this.hideControls || this.hideItemPerPage || !e ? h : n` <label class="pagination--label">Items per page</label>
              <ex-select
                hideClearIcon
                selected=${this.pageSize}
                @change="${(t) => this.updateRecordsPerPage(t)}"
                data-exo-locatorId-suffix=${p(this, "pagination-select")}
              >
                ${this.pageSizeOptions.map((t) => function(a) {
      return n`<ex-menu-item value=${a} label=${a} data-value=${a}
    >${a}</ex-menu-item
  >`;
    }(t))}
              </ex-select>`}
      </div>

      <div class="pagination--label">
        <label>
          ${this.selectedPage * this.pageSize - (this.pageSize - 1)}-${Math.min(this.pageSize * this.selectedPage, this.totalItems)}
          of ${this.totalItems}
        </label>
      </div>
    </div>`;
  }
  getPaginationRightSide(e) {
    return n` <div class="pagination-right-side">
      <div class="pagination--numbers">
        <ex-icon-button
          icon="Left caret"
          type="tertiary"
          circular=${!0}
          tooltipText="Previous page"
          ?disabled=${this.selectedPage < 2}
          @click=${() => this.goToPage(this.selectedPage - 1)}
          data-exo-locatorId-suffix=${p(this, "pagination-left-caret")}
        ></ex-icon-button>
        ${this.getPagination()}
        <ex-icon-button
          icon="Right caret"
          type="tertiary"
          circular=${!0}
          tooltipText="Next page"
          ?disabled=${this.selectedPage >= this.totalPages}
          @click=${() => this.goToPage(this.selectedPage + 1)}
          data-exo-locatorId-suffix=${p(this, "pagination-right-caret")}
        ></ex-icon-button>
      </div>

      <div id="pagination--jump" class="pagination-go-to-page">
        ${this.hideControls || this.hideGoToPage || !e ? h : n` <label class="pagination--label">Go to page</label>
              <ex-input
                type="number"
                placeholder="Go to"
                value="${this.pageNumber}"
                @blur=${(t) => this.updatePageNumber(t)}
                @keyup=${this.onKeyEnter}
                min="1"
                max=${this.maxPageNum}
                data-exo-locatorId-suffix=${p(this, "pagination-goto-input")}
              ></ex-input>
              <ex-button
                flavor="branded"
                type="tertiary"
                @click=${() => this.goToPage(this.pageNumber)}
                >Go</ex-button
              >`}
      </div>
    </div>`;
  }
  render() {
    const e = !this.isMobileView;
    return n`<div class="pagination--wrapper">
      ${this.getPaginationLeftSide(e)}
      ${this.getPaginationRightSide(e)}
    </div>`;
  }
}
i.styles = N, s([c({ type: Number })], i.prototype, "totalItems", 2), s([c({ type: Number })], i.prototype, "pageSize", 2), s([c({ type: Object })], i.prototype, "pageSizeOptions", 2), s([c({ type: Number })], i.prototype, "selectedPage", 2), s([c()], i.prototype, "type", 2), s([c({ type: Boolean, reflect: !0 })], i.prototype, "hideControls", 2), s([c({ type: Boolean, reflect: !0 })], i.prototype, "hideGoToPage", 2), s([c({ type: Boolean, reflect: !0 })], i.prototype, "hideItemPerPage", 2), s([P(".pagination--wrapper")], i.prototype, "paginationWrapper", 2), s([g()], i.prototype, "isMobileView", 2), s([g()], i.prototype, "maxPageNum", 2), s([g()], i.prototype, "pageNumber", 2), s([g()], i.prototype, "renderingMode", 2);
const T = (o = "") => {
  x("ex-pagination", i, o), y(o), k(o), z(o), w(o), $(o);
}, ae = v({ tagName: "ex-pagination", elementClass: i, react: u, events: { onChange: "on-change" }, displayName: "ExPagination", registerWebComponent: T });
export {
  ae as ExPagination,
  O as PaginationType,
  te as maxPages,
  I as pageSizeListOptions,
  T as register
};
